import { stats } from "@/mocks/site";

export default function StatsStrip() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-x-6 gap-y-8 px-4 py-10 md:grid-cols-4 md:px-8 md:py-12">
        {stats.map((item) => (
          <div key={item.label} className="text-center md:text-left">
            <p className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">
              {item.value}
              <span className="ml-1 text-base font-medium text-foreground-500">{item.suffix}</span>
            </p>
            <p className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}